import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl} from "@angular/forms";
import {IGenericKeyValue} from "../../../storage/interfaces/generic.interface";
import {GenericKeyValueFormGroup} from "../../../storage/models/generic-key-value-form-group";
import {SelectOption} from "@df/design-system-components";
import {TranslateService} from "@ngx-translate/core";
import {controlErrors, IFieldError} from "../../../providers/utils/form-errors";

@Component({
    selector: 'app-arkema-input-with-unit',
    templateUrl: './arkema-input-with-unit.component.html',
    styleUrls: ['./arkema-input-with-unit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ArkemaInputWithUnitComponent implements OnInit {

  @Input() controlFC: UntypedFormControl;
  @Input() unitControlFG: GenericKeyValueFormGroup;
  @Input() unitList: IGenericKeyValue[];
  @Input() class: string[];
  @Input() labelId: string;
  @Input() label: string = '';
  @Input() minValue: number = 0;
  @Input() maxValue: number;
  @Input() showErrors: boolean = true;
  @Input() readonly: boolean = false;
  @Input() required: boolean = false;
  @Input() step: number;
  @Input() hint: string = '';

  unitKeyFC = new UntypedFormControl();
  unitOptions: SelectOption<string>[] = [];

  constructor(private _translateService: TranslateService) { }

  ngOnInit(): void {
    // add unitflowrate value if null with first unit list value
    if (!this.unitControlFG.keyFC.value && !!this.unitList.length) {
      this.unitControlFG.patchValue(this.unitList[0], {emitEvent: true});
    }
    this.unitOptions = this.unitList.map(unit => ({value: unit.key, label: unit.value}));
    this.unitKeyFC.setValue(this.unitControlFG.keyFC.value);

    this.unitKeyFC.valueChanges.subscribe((key: string) => {
      const unit = this.unitList.find(u => u.key === key);
      if (unit) {
        this.unitControlFG.patchValue(unit, {emitEvent: true});
      }
    });
  }

  errors(): IFieldError[] {
    return controlErrors(this.controlFC, {
      required: this._translateService.instant('REQUIRED_FIELD'),
      min: `Minimum value is ${this.minValue}`,
      max: `Maximum value is ${this.maxValue}`
    });
  }

}
